import { PostMetricsInDto, GetMetricsOutDto } from "../../../types/post-views.dto";

export const GET_POST_METRICS = "GET_POST_METRICS";
export const GET_POST_METRICS_SUCCESS = "GET_POST_METRICS_SUCCESS";
export const GET_POST_METRICS_ERROR = "GET_POST_METRICS_ERROR";
export const RESET_POST_METRICS = "RESET_POST_METRICS";

export interface GetPostMetrics {
  type: typeof GET_POST_METRICS;
  payload: GetMetricsOutDto;
}

export interface GetPostMetricsSuccess {
  type: typeof GET_POST_METRICS_SUCCESS;
  payload: PostMetricsInDto;
}

export interface GetPostMetricsError {
  type: typeof GET_POST_METRICS_ERROR;
  payload: string | boolean;
}

export interface ResetPostMetrics {
  type: typeof RESET_POST_METRICS;
  payload: null;
}

export interface State {
  data: PostMetricsInDto | null;
  states: {
    success: boolean;
    loading: boolean;
    error: boolean | string;
  };
}

export const initialState: State = {
  data: null,
  states: {
    success: false,
    loading: false,
    error: false,
  },
};

export type Actions = GetPostMetrics | GetPostMetricsSuccess | GetPostMetricsError | ResetPostMetrics;

